export default __webpack_public_path__ + "07.e191af9.jpeg";